// extracted by mini-css-extract-plugin
export default {"icon":"useProvisionEntitySearchConfig-module__icon--t9LK6"};